import React from 'react'
import styled from 'styled-components'
import Icon, { IProps } from './Icon'
import JobTag from '../tag/JobTag'

interface ICircleIconProps extends IProps {
  hoverText?: string
  className?: string
}

const CircleIcon: React.FC<ICircleIconProps> = ({ className, ...props }) => {
  return (
    <StyledJobTag
      className={className}
      hoverText={props.hoverText}
      content={<Icon {...props} />}
    />
  )
}

const StyledJobTag = styled(JobTag)`
  background: ${({ theme }) => theme.colors.textLightest};
  padding: 4px;
  margin-left: auto;
  border-radius: 50%;
`
export default CircleIcon
